import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageDescription: {
    defaultMessage: 'Connect and manage your fulfillment providers so you can send your orders to them directly from ShipStation.',
    id: 'x7gNu7',
    description: 'Fulfillment Providers Page Description',
  },
  tooltipContent: {
    defaultMessage: 'A fulfillment provider is a third-party service that packs and ships your orders for you.',
    id: 'Tgyirp',
    description:
      'Fulfillment Providers Page Banner Button - "third-party" in this context means a separate, non-ShipStation-related entity',
  },
  vendorConnectPageDescription: {
    defaultMessage:
      'Connect and manage your fulfillment providers here. Then you can send your orders to them directly from ShipStation. <a>Learn more about fulfillment providers</a>.',
    id: 'FGniFx',
    description: 'Fulfillment Providers Page Description',
  },
});

export default messages;
